<div class="flex items-center gap-2 text-2xl font-bold text-steel-100">
  @if (icon) {
    <rma-icon [glyph]="icon" />
  }
  <p class="break-all" [class.blur]="blur">
    {{ isNumber ? (blur ? 250 : maskValue ? ((value | number) ?? '0' | maskWordChars) : (value | number)) : value }}
  </p>
</div>
@if (title) {
  <div class="text-steel-100 text-body">{{ title }}</div>
}
@if (blurb) {
  <div class="text-sm" [ngClass]="isBlurbDark ? 'text-steel-100' : 'text-steel-70'" [innerHtml]="blurb"></div>
}
